define(
  'sortByFilterHandler',[
    'builderShowcaseObserver',
    'event'
  ],
  (builderShowcaseObserver) => {
    'use strict';

    function SortByFilterHandler() {
    }

    function SortByFilterInitHandler() {
    }

    /**
    * @private
    * onSortByChanged: triggers the on change on the sorting options.
    *
    */
    function onSortByChanged(data) {
      const sortByList = document.querySelector('[data-component="sort-by-list"]');
      const selectedOption = sortByList[sortByList.selectedIndex];
      let sortBy = data.target.value;
      if (sortBy === null) {
        sortBy = selectedOption.value;
      }

      const updatedSearchParams = {
        ReviewSortBy: Number(sortBy)
      };

      builderShowcaseObserver.setParameters(updatedSearchParams);
      builderShowcaseObserver.commit();
      const state = builderShowcaseObserver.getState();
      state.data.ReviewSearchParams.ReviewSortBy = Number(sortBy);
      state.filterType = 'sortBy';
      const pageUrl = document.querySelector('[data-page-number="1"]').href;
      window.history.pushState({}, null, pageUrl);
      builderShowcaseObserver.OnSortByChanged(state);
    }

    /**
    * @private
    * SetListenersSortBy: set listeners for sort by select.
    *
    */
    function SetListenersSortBy() {
      const sortByList = document.querySelector('[data-component="sort-by-list"]');
      sortByList.addEventListener('change', onSortByChanged);
    }

    const events = {
      onSortByChanged: {
        callbacks: [onSortByChanged],
        elements: '[data-component="sort-by-list"]',
        events: ['change'],
      },
    };

    /**
    * @public
    * update: function for receiving notifications about state changes
    * @param {object} data information that was changed.
    *
    */
    SortByFilterHandler.update = function updateSortByValue(data) {
      onSortByChanged(data);
    };

    /**
    * @public
    * update: function for receiving notifications about state changes
    * @param {object} data information that was changed.
    *
    */
    SortByFilterInitHandler.update = function SetListeners() {
      SetListenersSortBy();
    };

    SetListenersSortBy();
    window.NewHomeSource.Event(events);
    builderShowcaseObserver.subscribe('onReviewsSectionLoaded', SortByFilterInitHandler);
  }

);

